import { Checkbox, MenuItem, Select, Typography } from '@material-ui/core';
import React, { Fragment } from 'react';

import { IWidgetGeneratorState } from '../..';
import getFormattedPropertyName from '../../../../lib/getFormattedPropertyName';
import Button from '../../../Button';
import ChatArea from '../../../ChatArea';
import ColorSelector from '../../../ColorSelector';
import ContextBubble from '../../../ContextBubble';
import { MaterialInput } from '../../../FormInput';
import FormTextArea from '../../../TextArea';
import { FormInputLabel } from '../../../Typography';
import SuggestedResponse from '../SuggestedResponse';

import { Column, ModalContent, RowContainer, Section } from '../../styled';
import { WidgetContainer } from './styled';

interface IWidgetEditorProps {
  options: IWidgetGeneratorState;
  updateWidget: (key: string, value: string | number | boolean | string[], refresh?: boolean) => void;
}

const behaviourCopy = 'Auto Pop refers to the widget automatically appearing on your site. You can set the delay to how many seconds before it pops up. You can change the settings for both web and mobile. Position determines which side the widget will appear on your site.';

const mainColorKeys = ['primaryAccentColor', 'primaryAccentTextColor', 'backgroundColor'];
const chatColorKeys = [
  'agentBubbleBackgroundColor',
  'agentBubbleTextColor',
  'bubbleBackgroundColor',
  'bubbleTextColor',
  'suggestedResponseColor',
];
const sendButtonColorKeys = ['sendButtonBackgroundColor', 'sendButtonTextColor'];

class WidgetEditor extends React.Component<IWidgetEditorProps> {

  protected widgetRef: any;

  public render() {
    const { options, updateWidget } = this.props;

    return (
      <Fragment>
        <Column>
          <Section>
            <FormInputLabel marginBottom bold>MESSAGING</FormInputLabel>
            <MaterialInput
              variant='outlined'
              label={'Header Title'}
              value={options.title}
              onChange={event => updateWidget('title', event.target.value)}
            />
            <FormTextArea
              value={options.initialMessage}
              onChange={event => updateWidget('initialMessage', event.target.value, true)}
            />
            <SuggestedResponse
              value={options.initialResponses}
              onChange={responses => updateWidget('initialResponses', responses, true)}
            />
          </Section>

          <Section>
            <RowContainer>
              <FormInputLabel bold>BEHAVIOR</FormInputLabel>
              <ContextBubble text={behaviourCopy} postitionLeft={-88} />
            </RowContainer>

            <RowContainer>
              <Typography variant='subtitle1'>AUTO POP</Typography>
              <Checkbox
                color='primary'
                checked={options.autoOpen}
                onChange={(_, checked) => updateWidget('autoOpen', checked)}
                value='primary'
              />
              <MaterialInput
                disabled={!options.autoOpen}
                marginTop
                variant='outlined'
                label={'Delay (seconds)'}
                value={options.autoOpenDelay ? options.autoOpenDelay.toString() : ''}
                onChange={event =>
                  updateWidget('autoOpenDelay', event.target.value)
                }
              />
            </RowContainer>

            <RowContainer>
              <Typography variant='subtitle1'>AUTO POP MOBILE</Typography>
              <Checkbox
                color='primary'
                checked={options.autoOpenMobile}
                onChange={(_, checked) => updateWidget('autoOpenMobile', checked)}
                value='primary'
              />
              <MaterialInput
                disabled={!options.autoOpenMobile}
                marginTop
                variant='outlined'
                label={'Delay (seconds)'}
                value={options.autoOpenMobileDelay ? options.autoOpenMobileDelay.toString() : ''}
                onChange={event => updateWidget('autoOpenMobileDelay', event.target.value)}
              />
            </RowContainer>

            <RowContainer>
              <Typography style={{ marginRight: '1rem' }} variant='subtitle1'>POSITION</Typography>
              <Select
                value={options.position}
                onChange={(e) => updateWidget('position', e.target.value as string)}>
                <MenuItem value={'right'}>Right</MenuItem>
                <MenuItem value={'left'}>Left</MenuItem>
              </Select>
            </RowContainer>
          </Section>

          <Section>
            <FormInputLabel bold>MAIN COLORS</FormInputLabel>
            {mainColorKeys.map(colorKey => (
              <ColorSelector
                key={colorKey}
                title={getFormattedPropertyName(colorKey)}
                color={options[colorKey]}
                onChange={(color) => updateWidget(colorKey, color.hex)} />
            ))}
          </Section>

          <Section>
            <FormInputLabel bold>CHAT COLORS</FormInputLabel>
            {chatColorKeys.map(colorKey => (
              <ColorSelector
                key={colorKey}
                title={getFormattedPropertyName(colorKey)}
                color={options[colorKey]}
                onChange={(color) => updateWidget(colorKey, color.hex)} />
            ))}
          </Section>

          <Section>
            <FormInputLabel bold>BUTTON COLORS</FormInputLabel>
            {sendButtonColorKeys.map(colorKey => (
              <ColorSelector
                key={colorKey}
                title={getFormattedPropertyName(colorKey)}
                color={options[colorKey]}
                onChange={(color) => updateWidget(colorKey, color.hex)} />
            ))}
          </Section>

          <Section>
            <FormInputLabel bold>LOGO (OPTIONAL)</FormInputLabel>
            <RowContainer>
              <MaterialInput
                variant='outlined'
                fullWidth
                marginRight
                marginTop
                label={'URL'}
                value={options.tempLogoUrl}
                onChange={event => updateWidget('tempLogoUrl', event.target.value)}
              />
              <Button
                colorOverride={'#6277E2'}
                size='small'
                secondary
                onClick={() => updateWidget('logoUrl', options.tempLogoUrl)}
              >
                Update
                </Button>
            </RowContainer>
          </Section>
        </Column>

        <Column>
          <WidgetContainer width={options.width} height={options.height}>
            <ModalContent>
              <ChatArea options={options} name={'You'} ref={(o) => this.widgetRef = o} />
            </ModalContent>
          </WidgetContainer >
        </Column>
      </Fragment>
    );
  }

  public refreshWidget() {
    this.widgetRef && this.widgetRef.setGeneratorWidget();
  }

}

export default WidgetEditor;
